// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-radio-label {
  font-size: 13px;
}

.auth-app p {
  color: #333333;
  font-family: var(--font-secondary) !important;
  font-weight: 500;
  font-size: 22px;
}

.text-underline {
  text-decoration: underline;
}

@media screen and (max-width: 576px) {
  ion-grid {
    margin: 0.5rem 1.5rem 0.5rem 2rem !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/pages/authenticator/change-authenticator-option/change-authenticator-option.component.scss"],"names":[],"mappings":"AACA;EACI,eAAA;AAAJ;;AAII;EACE,cAAA;EACA,6CAAA;EACA,gBAAA;EACA,eAAA;AADN;;AAKA;EACE,0BAAA;AAFF;;AAME;EADF;IAEM,4CAAA;EAFJ;AACF","sourcesContent":["\r\n.custom-radio-label {\r\n    font-size: 13px;\r\n}\r\n\r\n.auth-app{\r\n    p{\r\n      color: #333333;\r\n      font-family: var(--font-secondary) !important;\r\n      font-weight: 500;\r\n      font-size: 22px;\r\n    }\r\n  }\r\n\r\n.text-underline {\r\n  text-decoration: underline;\r\n}\r\n\r\nion-grid {\r\n  @media screen and (max-width:576px) {\r\n      margin: .5rem 1.5rem .5rem 2rem !important;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
